export default "__VITE_ASSET__Cn6ED0t4__"